var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "orders-filter--block flex-center-center flex-column" },
    [
      _c("div", { staticClass: "headingLine" }, [_vm._v("Mes Commandes")]),
      _vm._v(" "),
      _c("div", { staticClass: "text-white display-5 bg-white radius-5 p-5" }, [
        _vm._v(
          _vm._s((_vm.orders && _vm.orders.length) || 0) +
            " " +
            _vm._s(
              _vm.orders && _vm.orders.length == 1 ? "commande" : "commandes"
            ) +
            " "
        ),
        _c("i", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "loading",
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "filters-content container p-0 flex-center-center flex-wrap mt-40",
        },
        [
          _c(
            "div",
            { staticClass: "calendarSelect flex-center-center flex-wrap" },
            [
              _c("div", { staticClass: "fromDate m-5" }, [
                _c("div", { staticClass: "input-group" }, [
                  _c("div", { staticClass: "input-group-addon" }, [
                    _vm._v("Du"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ordersFilter.fromDate,
                        expression: "ordersFilter.fromDate",
                      },
                    ],
                    staticClass:
                      "form-control border-left-0 border-right-0 p-5",
                    attrs: { type: "date" },
                    domProps: { value: _vm.ordersFilter.fromDate },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.ordersFilter,
                          "fromDate",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "toDate m-5" }, [
                _c("div", { staticClass: "input-group" }, [
                  _c("div", { staticClass: "input-group-addon" }, [
                    _vm._v("Au"),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.ordersFilter.toDate,
                        expression: "ordersFilter.toDate",
                      },
                    ],
                    staticClass:
                      "form-control border-left-0 border-right-0 p-5",
                    attrs: { type: "date" },
                    domProps: { value: _vm.ordersFilter.toDate },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.$set(
                          _vm.ordersFilter,
                          "toDate",
                          $event.target.value
                        )
                      },
                    },
                  }),
                ]),
              ]),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }